<template>
    <div>
        Stripe Refresh
    </div>
</template>

<script>
    export default {
        name: "StripeRefresh",
        head: {
            title: 'Stripe | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Description'
                }
            ],
        },
    }
</script>
